import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import Activity from "./components/Activity/Activity";
import ManageDocs from "./components/ManageDocs/ManageDocs";
import Notifications from "./components/Notifications/Notifications";
import Logs from "./components/Logs/Logs";
import FindDocs from "./components/FindDocs/FindDocs";
import CreatorMode from "./components/CreatorMode/CreatorMode";
import Layout from "./components/Layout/Layout";
import CreateDocument from "./components/Activity/CreateDocument/CreateDocument";
import DocumentStatus from "./components/Activity/DocumentStatus/DocumentStatus";
import SubmittedDocument from "./components/Activity/SubmittedDocument/SubmittedDocument";
import DocumentTemplateSelector, { FilePlanGrid } from "./components/DocumentTemplateSelector/DocumentTemplateSelector";
import Login from "./components/Login/Login";
import Disposal from "./components/Disposal/Disposal";
import { ToastContainer } from "react-toastify";

// Helper to check authentication
const isAuthenticated = () => {
  return !!localStorage.getItem("formioToken");
};

// Protect private routes
const PrivateRoute = ({ element }) => {
  return isAuthenticated() ? element : <Navigate to="/login" replace />;
};

// Prevent logged-in users from seeing login page
const PublicRoute = ({ element }) => {
  return isAuthenticated() ? <Navigate to="/" replace /> : element;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
      <ToastContainer />
        <Routes>
          <Route
            path="/"
            element={<PrivateRoute element={<Layout />} />}
          >
            <Route index element={<Navigate to="/activity" replace />} />
            <Route path="activity" element={<Activity />} />
            <Route path="activity/select-plan" element={<FilePlanGrid />} />
            <Route path="activity/select-template" element={<DocumentTemplateSelector />} />
            <Route path="activity/create/:formId" element={<CreateDocument />} />
            <Route path="activity/status/:submitId" element={<DocumentStatus />} />
            <Route path="activity/submitted-documents/:submitId" element={<SubmittedDocument />} />
            <Route path="manage-docs" element={<ManageDocs />} />
            <Route path="maintenance" element={<FilePlanGrid type="maintenance" />} />
            <Route path="maintenance/select-series" element={<DocumentTemplateSelector type="maintenance" />} />
            <Route path="disposal" element={<Disposal />} />
            <Route path="notifications" element={<Notifications />} />
            <Route path="logs" element={<Logs />} />
            <Route path="find-docs" element={<FindDocs />} />
            <Route path="creator-mode" element={<CreatorMode />} />
          </Route>
          <Route
            path="/login"
            element={<PublicRoute element={<Login />} />}
          />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;